import React from 'react'

export const Footer = () => {
  return (
        <div className='bg-primary p-2 text-light w-100 text-center'>
            <p className='fs-3 font-monospace fw-bold'>Copyright <span className='fw-bold text-warning'>Auxo Digitals Private Limited</span>. All rights Reserved</p>
            <p className='fs-5 font-monospace fw-light'>Designed and made by Piyush Kesarwani with JS and ReactJs in 2022</p>
        </div>
  )
}
